import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReAuth } from './base-api';

export const v4ApiReducerPath = 'v4Api';

export const emptyV4Api = createApi({
  reducerPath: v4ApiReducerPath,
  baseQuery: baseQueryWithReAuth,
  endpoints: () => ({}),
});
